import styled from "styled-components"
import { Mobile, PC, Tablet } from '../component/MediaQuery'
import Typography from '../component/Typography'
import i18n from '../../locales'
import { Link, useNavigate } from 'react-router-dom'

const FooterWrap = styled.footer`
    min-width: 1200px;
    background-color: #FBFBFB;
    padding: 54px 40px 24px;
    > div {
        max-width: 1920px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 24px 0;
        > article {
            display: flex;
            align-items: center;
            gap: 0 18px;
            > a {
                width: 48px;
                height: 48px;
                border-radius: 24px;
                background-color: white;
                filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.2));
            }
        }
        > section {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 8px 0;
            div {
                display: flex;
                align-items: center;
                gap: 0 24px;
            }
        }
        > figure {
            display: flex;
            align-items: center;
            justify-content: center;
            a {
                color: #999999;
                font-size: 13px;
                &:hover {
                    color: #7A7A7A;
                }
            }
        }
        > aside {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0 16px;
            button {
                font-size: 13px;
                color: #7A7A7A;
                border: 0;
                background-color: transparent;
                padding: 0;
                transition: all 0.3s ease;
                cursor: pointer;
                &:hover {
                    color: #568DFD;
                }
            }
            span {
                font-size: 10px;
            }
        }
    }
    @media (min-width:600px) and (max-width: 1199px) {
        min-width: 600px;
        padding: 48px 30px 32px;
        > div {
            > section {
                div {
                    flex-direction: column;
                    gap: 8px 0;
                    text-align: center;
                }
            }
        }
    }
    
    @media (max-width: 599px) {
        min-width: 100%;
        padding: 48px 20px 80px;
        > div {
            > section {
                div {
                    flex-direction: column;
                    gap: 8px 0;
                    text-align: center;
                }
            }
        }
    }
`

interface FooterProps {
    onChangeLanguage: (value: string) => void
}

const FooterEn = (props: FooterProps) => {
    const { onChangeLanguage } = props
    const navigate = useNavigate()

    return (
        <FooterWrap>
            <div>
                <article>
                    <a href="https://www.youtube.com/channel/UCeBJYPGZjceVjLWKZ00ccPg" target='_blank' rel="noreferrer">
                        <img src="/assets/images/sns_youtube.svg" alt="youtube" />
                    </a>
                    <a href="https://twitter.com/GripJp" target='_blank' rel="noreferrer">
                        <img src="/assets/images/sns_twitter.svg" alt="twitter" />
                    </a>
                    <a href="https://www.linkedin.com/showcase/grip-cloud-japan/" target='_blank' rel="noreferrer">
                        <img src="/assets/images/sns_linkedin.svg" alt="linkedin" />
                    </a>
                </article>
                <section>
                    <PC>
                        <div>
                            <Typography label='Grip Company Co.,Ltd., Republic of Korea Company' size={13} color='#7A7A7A' />
                            <Typography label='Registration Number : 229-87-01063' size={13} color='#7A7A7A' />
                        </div>
                        <div>
                            <Typography label='Company Address : 11F, Pangyoyeok-ro 152, Bundang, Sungnam-city, Gyounggi-Do' size={13} color='#7A7A7A' />
                            <Typography label='gripcloud@gripcorp.co' size={13} color='#7A7A7A' />
                        </div>
                    </PC>
                    <Tablet>
                        <div>
                            <Typography label='Grip Company Co.,Ltd., Republic of Korea Company' size={13} color='#7A7A7A' />
                            <Typography label='Registration Number : 229-87-01063' size={13} color='#7A7A7A' />
                            <Typography label='Company Address : 11F, Pangyoyeok-ro 152, Bundang, Sungnam-city, Gyounggi-Do' size={13} color='#7A7A7A' />
                            <Typography label='gripcloud@gripcorp.co' size={13} color='#7A7A7A' />
                        </div>
                    </Tablet>
                    <Mobile>
                        <div>
                            <Typography label='Grip Company Co.,Ltd., Republic of Korea Company' size={13} color='#7A7A7A' />
                            <Typography label='Registration Number : 229-87-01063' size={13} color='#7A7A7A' />
                            <Typography label='Company Address : 11F, Pangyoyeok-ro 152, Bundang, Sungnam-city, Gyounggi-Do' size={13} color='#7A7A7A' />
                            <Typography label='gripcloud@gripcorp.co' size={13} color='#7A7A7A' />
                        </div>
                    </Mobile>
                </section>
                <figure>
                    <Link to='https://hubspot.gripcloud.show/privacy-notice' target='_blank'>privacy policy</Link>
                </figure>
                <Typography label='© 2018 GripCompany' size={13} color='#7A7A7A' />
                <aside>
                    <button
                        onClick={() => {
                            onChangeLanguage('ko')
                            i18n.changeLanguage('ko')
                            navigate('kr')
                        }}
                    >
                        한국어
                    </button>
                    <span>|</span>
                    <button
                        onClick={() => {
                            onChangeLanguage('en')
                            i18n.changeLanguage('en')
                            navigate('en')
                        }}
                    >
                        English
                    </button>
                    <span>|</span>
                    <button
                        onClick={() => {
                            onChangeLanguage('ja')
                            i18n.changeLanguage('ja')
                            navigate('jp')
                        }}
                    >
                        日本語
                    </button>
                </aside>
            </div>
        </FooterWrap>
    )
}

export default FooterEn
